module.exports = __webpack_public_path__ + "img/bj4.f36c5a03.png";